import type { IntercomJWT, IntercomJWTParams } from './types';

import { apiClient } from '~shared/api/createApiClient';

export const getIntercomJWT = (
  params: IntercomJWTParams
): Promise<IntercomJWT> => {
  const { pharmacyId, name, email, role } = params;

  return apiClient.post<IntercomJWT>(
    '/api/intercom/jwt',
    { name, email, role },
    { pharmacyId }
  );
};
